@use '../../styling/colors.scss' as *;
@use '../../styling/typography.scss' as *;

$size: 1.5em;

.TogglePassword {
  display: block;
  position: relative;

  input {
    width: 100%;
    padding-right: $size + 1em;
  }

  button {
    padding: 0;
    right: 0.8125em;
    top: 10%;
    border: none;
    background: none;
    bottom: 0;
    position: absolute;
    cursor: pointer;

    svg {
      &:hover,
      &:active,
      &:focus {
        color: $color-grey-B;
      }

      height: $size;
      width: $size;
      color: $color-grey-C;
    }
  }
}
